import React from 'react';
import { connect } from 'react-redux';
import * as MaterialUI from 'material-ui';

import * as generalActions from 'modules/general/action';

/*
props
listComponent
hintText
buscar
title
nameId
*/

@connect(store => ({
  open: store.getIn(['general', 'seleccionador', 'open']),
  listas: store.getIn(['general', 'seleccionador', 'listas']),
}))
export default class extends React.Component {
  cancelar = () => {
    this.props.dispatch(generalActions.seleccionador_close());
  };
  render() {
    return (
      <MaterialUI.Dialog
        title={this.props.title}
        actions={[<MaterialUI.RaisedButton key={1} label="Cancelar" secondary={true} onTouchTap={this.cancelar} fullWidth={true} />]}
        className="confirmationDialog"
        autoScrollBodyContent={true}
        open={this.props.open ? (this.props.nameId ? this.props.open == this.props.nameId : true) : false}
        onRequestClose={this.props.cancelar}
      >
        <MaterialUI.TextField hintText="Buscar" floatingLabelText={this.props.searchText} fullWidth={true} onChange={(e, value) => this.props.buscar(value)} />
        {this.props.listas.get(this.props.nameId || this.props.open) &&
          this.props.listas.get(this.props.nameId || this.props.open).map(item => (
            <div key={item.get('id')}>
              {this.props.listComponent(item, this.props.dispatch, this.cancelar, this.props.data)}
              <MaterialUI.Divider />
            </div>
          ))}
      </MaterialUI.Dialog>
    );
  }
}



// WEBPACK FOOTER //
// src/modules/general/components/seleccionador.js